export function getVirtualWindow(scrollTop, rowHeight, viewportHeight, itemCount, overscan = 5) {
  const safeCount = Math.max(0, Number(itemCount) || 0);
  const safeRowHeight = Math.max(1, Number(rowHeight) || 1);
  const safeViewportHeight = Math.max(0, Number(viewportHeight) || 0);
  const safeOverscan = Math.max(0, Number(overscan) || 0);
  const start = Math.max(0, Math.floor(Math.max(0, scrollTop) / safeRowHeight) - safeOverscan);
  const end = Math.min(
    safeCount,
    Math.ceil((Math.max(0, scrollTop) + safeViewportHeight) / safeRowHeight) + safeOverscan,
  );

  return { start, end, topPadding: start * safeRowHeight, bottomPadding: (safeCount - end) * safeRowHeight };
}
